"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagBF = function FlagBF(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6,12.18H-193V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,12.18H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06H-185.94A7.06,7.06,0,0,1-193,139.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14-26.34,22.83.3,50.91.52a2.27,2.27,0,0,1,1.33,4.09L29.65,21.29l8.47,26.78a2.26,2.26,0,0,1-3.47,2.52L11.8,34.26-11,50.59a2.26,2.26,0,0,1-3.47-2.52L-6,21.29-28.64,4.61A2.27,2.27,0,0,1-27.31.52L.77.3,9.66-26.34a2.26,2.26,0,0,1,4.29,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagBF;
exports["default"] = _default;